import { A11y, Pagination, Scrollbar } from 'swiper/modules';

class ProductInformation {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-productinformation'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$productInformation = $element;
        this.$$sealsSlides = this.$productInformation.querySelectorAll('[' + this.settings.initAttr + '="slide"]');
        this.sealsSlider = null;

        this.resizeHandler = window.resizeHandler;
        this.sealsSliderActive = false;

        if (this.$$sealsSlides.length > 1) {
            import(
                /* webpackChunkName: "slider/slider.js" */
                './../../../components/slider/slider').then(({ Slider }) => {
                this.Slider = Slider;
                this.initialize();
            });
        }
        // this.initialize();
    }

    initialize () {
        this.checkSize();
        this.resizeHandler.customFunctions.push(() => {
            this.checkSize();
        });
    }

    checkSize () {
        if (window.innerWidth < 768 && this.$$sealsSlides.length > 2) {
            if (this.sealsSliderActive === false) {
                this.initSlider();
            }
        } else if (window.innerWidth < 1024 && this.$$sealsSlides.length > 4) {
            if (this.sealsSliderActive === false) {
                this.initSlider();
            }
        } else {
            if (this.sealsSliderActive === true) {
                this.destroySlider();
                this.sealsSliderActive = false;
            }
        }
    }

    initSlider () {
        this.sealsSlider = new this.Slider(this.$productInformation, {
            modules: [A11y, Pagination, Scrollbar],
            speed: 500,
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            centeredSlides: true,
            centeredSlidesBounds: true,
            initAttr: this.settings.initAttr,
            fractionText: '•',
            prevnext: false,
            scrollbar: true,
            scrollbarAppendToControls: true,
            counter: true,
            counterCustom: true
        });

        this.sealsSliderActive = true;
    }

    destroySlider () {
        if (typeof this.sealsSlider !== 'undefined' && this.sealsSlider !== null) {
            this.sealsSlider.destroy();
        }
    }
}

export { ProductInformation };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$ProductInformation = $context.querySelectorAll('[data-productinformation="root"]');
        for (let i = 0; i < $$ProductInformation.length; i++) {
            const $ProductInformation = $$ProductInformation[i];

            const ProductInformationAPI = new ProductInformation($ProductInformation);
            $ProductInformation.API = ProductInformationAPI;
        }
    }
});
